export default "__VITE_ASSET__0USaXDsc__"